import { Head } from "@inertiajs/react"
import { SonarLayout } from "@/components/sonar"
import { SalesReport, type SalesReportData } from "@/components/sales-report"

interface SalesReportPageProps {
  report: SalesReportData
}

export default function SalesReportPage({ report }: SalesReportPageProps) {
  return (
    <>
      <Head title="Sales Report">
        <meta
          name="description"
          content="True Sales, recognised revenue, pipeline and the settlement bridge by month — toggle currency (EUR / USD / Consolidated) and lens."
        />
        <meta property="og:title" content="Sales Report" />
        <meta
          property="og:description"
          content="True Sales, recognised revenue, pipeline and the settlement bridge by month — toggle currency (EUR / USD / Consolidated) and lens."
        />
      </Head>
      <SonarLayout>
        <SalesReport report={report} />
      </SonarLayout>
    </>
  )
}
